import { ThrowStmt } from "@angular/compiler";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { ValueConverter } from "@angular/compiler/src/render3/view/template";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, FormGroupName, NgForm, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef, NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import Stepper from "bs-stepper";
import * as moment from "moment";
import { Subject } from "rxjs";
import { filter, first, retryWhen, take, takeUntil } from "rxjs/operators";
import { PlaceholderEmailValidator, SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { PositiveNumberValidator } from "src/app/directives/positive-number.directive";
import { VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { validarRut } from "src/app/directives/verifica-rut.directive";
import { formatToRut } from "src/app/directives/formatToRut.directive";
import { RutHelper } from "src/app/helpers/rut.helper";
import { ActividadEconomica } from "src/app/models/ActividadEconomica";
import { ActividadEconomicaEmisor } from "src/app/models/ActividadEconomicaEmisor";
import { Ambiente } from "src/app/models/Ambiente";
import { TipoProveedorCorreo } from "src/app/models/CasillaDteRecibidos/TipoProveedorCorreo";
import { CertificadoDigital } from "src/app/models/CertificadoDigital/CertificadoDigital";
import { ConfiguracionEmision } from "src/app/models/ConfiguracionEmision";
import { CuentaSii } from "src/app/models/CuentaSii";
import { Adicional } from "src/app/models/Emisor/Adicional";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { CertificadoRequest, ConsumoFolio, EmisorWizardRequest, FolioRequest, PlantillaFileRequest } from "src/app/models/Emisor/EmisorWizardRequest";
import { LogoEmisorRequest } from "src/app/models/Emisor/LogoEmisorRequest";
import { LogoWizardRequest } from "src/app/models/Emisor/LogoWizardRequest";
import { FolioFileObject } from "src/app/models/Folio/FolioFileObject";
import { FormatoPapel } from "src/app/models/FormatoPapel";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { CertificadoCompraWizard } from "src/app/models/Emisor/EmisorWizardRequest";
import { DatosFacturacion, EmpresaFacturacion } from "src/app/models/PlanesUsuario/DatosFacturacion";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { PlantillaImpresion } from "src/app/models/PlantillaImpresion/PlantillaImpresion";
import { Sucursal } from "src/app/models/Sucursal";
import { TipoDte } from "src/app/models/tipoDte";
import { AuthService } from "src/app/modules/auth";
import { CertificadosDigitalesService } from "src/app/services/certificados-digitales.service";
import { CypressService } from "src/app/services/cypress.service";
import { DatosFacturacionService } from "src/app/services/datos-facturacion-service";
import { EmisorService } from "src/app/services/emisor.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { WebpayPaymentService } from "src/app/services/webpay-payment.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import Swal from "sweetalert2";
import { CERT_PRECIOS } from "src/app/components/configuracion-dte/mantenedor-certificados/config-certificados";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { CertificadoDigitalRequest } from "src/app/models/CertificadoDigital/CertificadoDigitalRequest";
import { OrigenCertificadoEnum } from "src/app/models/CertificadoDigital/OrigenCertificadoEnum";
import { SessionUserService } from "src/app/modules/auth/session-user/session-user.service";
import { element } from "protractor";
import { TourService } from "src/app/services/tour-tutorial.service";
import { ConfiguracionesTour } from "src/app/shared/models/tour-tutorial-configurations";
import { ClienteService } from "src/app/services/cliente.service";
import { SiiSearchService } from "src/app/services/sii-search.service";
import { ResolucionData } from "src/app/models/ResolucionData";
import { AdicionalType } from "src/app/shared/models/AdicionalType.enum";
import { EstadoBorradorWizardEmisor } from "src/app/models/Emisor/estado-borrador-wizard-emisor";
import { BorradorWizardEmisorService } from "src/app/services/borrador-wizard-emisor.service";
@Component({
	selector: "app-wizard-emisor",
	templateUrl: "./wizard-emisor.component.html",
	styleUrls: ["./wizard-emisor.component.scss"],
})
export class WizardEmisorComponent implements OnInit {
	private isInTutorial: boolean = false;
	private stepper: Stepper;
	@ViewChild("stepper1") stepperRef: ElementRef;
	@ViewChild("emisorBaseFormRef") public emisorBaseFormRef;
	@ViewChild("sucursalLocalFormRef") public sucursalLocalFormRef;
	@ViewChild("actividadLocalFormRef") public actividadLocalFormRef;
	@ViewChild("logoLocalFormRef") public logoLocalFormRef;
	@ViewChild("emisorPagoFormRef") public pagoLocalFormRef;
	@ViewChild('certificacionFechaForm') certificacionFechaFormTemplate: TemplateRef<any>;
	@ViewChild('certPopover') certPopover: NgbPopover;
	private cerrarCertPopoverTimeout: any;

	abrirCertPopover() {
		clearTimeout(this.cerrarCertPopoverTimeout);
		if (this.certPopover && !this.certPopover.isOpen()) {
			this.certPopover.open();
		}
	}

	programarCierreCertPopover() {
		clearTimeout(this.cerrarCertPopoverTimeout);
		this.cerrarCertPopoverTimeout = setTimeout(() => {
			if (this.certPopover && this.certPopover.isOpen()) {
				this.certPopover.close();
			}
		}, 250);
	}

	public emisorSuperGroup: FormGroup;
	public emisorBasicFormGroup: FormGroup;
	public emisorDatosFacturacionFormGroup: FormGroup;
	public emisorSucursalesFormGroup: FormGroup;
	public economicActivityFormGroup: FormGroup;
	public logoFormGroup: FormGroup;
	public pagoFormGroup: FormGroup;
	public facturacionFormGroup: FormGroup;
	public emisor: FormGroup;
	public certificadoFormGroup: FormGroup;
	public configEmisionFormArray: FormArray;

	public economicActivitiesList: ActividadEconomica[] = [];
	public economicActivitiesSource: ActividadEconomica[] = JSON.parse(this.localStorage.getActividadesEconomicas()) as ActividadEconomica[];
	public empresasFacturacionSource: EmpresaFacturacion[] = [];
	//public selectedEmpresa: EmpresaFacturacion;

	//public environmentType = ["Certificacion", "Produccion"];
	public environmentType: Ambiente[] = JSON.parse(this.localStorage.getTipoAmbiente()) as Ambiente[];
	private emisorBaseToSend: Emisor = new Emisor();
	private sucursalToSend: Sucursal = new Sucursal();
	private datosFacturacion: DatosFacturacion = new DatosFacturacion();
	private activitiesToSend: ActividadEconomicaEmisor[] = [];
	private foliosToSend: FolioRequest[] = [];
	private plantillasToSend: PlantillaFileRequest[] = [];
	//private configsEmisionToSend: ConfiguracionEmision[] = [];
	private certificadoToSend: CertificadoRequest = new CertificadoRequest();
	public logoRequest: LogoEmisorRequest = new LogoEmisorRequest();
	private logoWizardRequest: LogoWizardRequest = new LogoWizardRequest();

	// public tipoDteFullSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
	// public tiposDteAgrupados = JSON.parse(this.localStorage.getDteTypesAgrupados()) as TipoDteAgrupado[];
	public selectedTiposDte: TipoDte[] = [];
	public submittedChildrenFormsArray: boolean[] = [false, false, false, false, false, false, false];
	public fileToUploadArray: File[] = [];
	public emailPattern = '[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$';
	public configuracionFormGroup: FormGroup;
	public certificadoFileToUpload: File;
	public certificadoFilesArray: File[] = [];
	public logosFilesArray: any[] = [];
	public loginLogoFilesArray: File[] = [];
	public logoLoginPreview: string = null;
	public tipoPlantillasSource: PlantillaImpresion[] = [];
	public formatoPapelSource: FormatoPapel[] = JSON.parse(this.localStorage.getFormatoPapel()) as FormatoPapel[];
	private cuentaSiiFormGroup: FormGroup;
	public loading: boolean = false;
	private searchingCompany: boolean = false;
	private prevSearch: string;
	private destroy$ = new Subject<void>();
	public domiciliosFromSii: any[] = [];
	public showDomiciliosCombo: boolean = false;
	public domicilioSeleccionado: any = null;
	private emisorId = this.tokenService.getCompany();
	public certificaciones: CertificacionPrecio[];
	public adicionales: Adicional[] = [];
	public resumenCuenta: Resumen;
	public isReseller: boolean = this.tokenService.userHasReseller();
	// public formaPago: string;
	private modalSIIHelp: NgbModalRef;

	locale = {
		startDate: moment(),
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	public validDate: boolean = true;
	public user: SessionUser;
	public isSuperAdmin: boolean;
	public mostrarOpcionesCertificado: boolean = false;
	public compraCertificado: CertificadoCompraWizard = {
		comprar: false,
		duracion: null,
		garantia: false,
		preciobase: 0,
		precioGarantia: 0,
		total: 0,
		certificadoGenerado: false,
	};
	public CERT_PRECIOS = CERT_PRECIOS;
	public fechaCertificacion: string;
	private certificacionFechaModal: NgbModalRef;
	public fechaActual = moment();
	public resumenBorrador: Resumen | null = null;
	public codigosCertificacionesBorrador: number[] = [];
	public certificadoRestaurado: boolean = false;
	private procesoFinalizado: boolean = false;
	private temporizadorGuardadoBorrador: any;

	get hayCertificacionesSeleccionadas(): boolean {
		return this.certificaciones && this.certificaciones.some(c => c.solicitada);
	}

	constructor(
		private formBuilder: FormBuilder,
		private modalService: NgbModal,
		private authService: AuthService,
		private utilities: UtilitiesService,
		private tokenService: TokenStorageService,
		private localStorage: LocalStorageService,
		private auth: AuthService,
		public permissions: PermissionService,
		private ref: ChangeDetectorRef,
		private emisorService: EmisorService,
		private cypressService: CypressService,
		private certificadoService: CertificadosDigitalesService,
		private router: Router,
		private datosFacturacionService: DatosFacturacionService,
		private pagoService: PagoUsuarioService,
		private sessionUserService: SessionUserService,
		private tourService: TourService,
		private clientService: ClienteService,
		private siiSearchService: SiiSearchService,
		private webpayService: WebpayPaymentService,
		private borradorWizardService: BorradorWizardEmisorService
	) {
		this.user = this.tokenService.getUser() as SessionUser;
		this.isSuperAdmin = this.tokenService.getUser().superAdmin;
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.setSuperForm();
		this.datosFacturacionService.getData(this.tokenService.getUser().id, null).subscribe((res) => {
			this.empresasFacturacionSource = res;
		});

		this.economicActivitiesSource = this.economicActivitiesSource.map((ae) => ({
			...ae,
			displayText: `${ae.codigo} - ${ae.descripcion}`,
		}));
		/*this.emisorSuperGroup.controls.base.get("ambiente").valueChanges.subscribe((ambienteSeleccionado) => {
			this.onAmbienteChange(ambienteSeleccionado);
		});*/
	}

	ngOnDestroy(): void {
		clearTimeout(this.temporizadorGuardadoBorrador);
		if (!this.procesoFinalizado) {
			this.guardarBorradorInmediato();
			void this.guardarBorradorAlSalir();
		}
		this.destroy$.next();
		this.destroy$.complete();
	}
	async ngAfterViewInit() {
		this.stepperInit();
		const existeBorrador = await this.mostrarAvisoRestaurarBorrador();
		if (!existeBorrador) {
			this.iniciarTourSiEsPrimeraVez();
		}
	}

	iniciarTourSiEsPrimeraVez() {
		if (!this.user.configured) {
			setTimeout(() => {
				const elementosRequeridos = ["#wizStepDatosEmpresa", "#wizStepActividadEco", "#wizStepCertificadoDigital", "#wizStepLogo", "#wizStepPlanes", "#wizStepCertificacion", "#wizStepFormaPago","#wizStepAmbiente", "#wizPassSII", "#wizStepConfiguracion", "#wizStepDatosFacturacion"];
				const elementosFaltantes = elementosRequeridos.filter((selector) => !document.querySelector(selector));

				if (elementosFaltantes.length > 0) {
					setTimeout(() => this.iniciarTourSiEsPrimeraVez(), 1000);
					return;
				}

				this.isInTutorial = true;
				this.tourService.iniciarTour(ConfiguracionesTour.WIZARD_EMISOR, {
					navegarAPaso: (indice: number) => this.navegarAIndiceWizard(indice),
					enCambioPaso: (indice: number) => this.accionesEspecialesTour(indice),
					alFinalizar: () => {
						this.isInTutorial = false;
					},
				});
			}, 1000);
		}
	}

	accionesEspecialesTour(indice: number) {
		if (indice === 5) {
			setTimeout(() => {
				const combo = document.querySelector('ng-select[formControlName="actividadEconomica"]') as HTMLElement;
				if (combo) {
					const contenedor = combo.querySelector(".ng-select-container") || combo;
					if (contenedor) {
						contenedor.classList.add("tour-highlight");
						setTimeout(() => contenedor.classList.remove("tour-highlight"), 2500);
					}
				}
			}, 1000);
		}
	}

	navegarAIndiceWizard(indice: number) {
		let stepperObj: any = this.stepper;
		if (stepperObj._currentIndex !== indice) {
			this.stepper.to(indice + 1);
		}
	}
	public verTutorial(): void {
		this.isInTutorial = true;
		this.tourService.iniciarTour(ConfiguracionesTour.WIZARD_EMISOR, {
			navegarAPaso: (indice: number) => this.navegarAIndiceWizard(indice),
			enCambioPaso: (indice: number) => this.accionesEspecialesTour(indice),
			alFinalizar: () => {
				this.isInTutorial = false;
			},
		});
	}
	next($event, childFormRef?) {
		let stepperObj: any = this.stepper;
		if (this.checkValidityOfCurrentForm(stepperObj._currentIndex)) {
			this.stepper.next();
		}
	}
	previous() {
		this.stepper.previous();
	}

	onSubmit() {
		if (this.isSuperAdmin) {
			this.emisorSuperGroup.controls.facturacion.clearValidators();
		}
		this.emisorSuperGroup.updateValueAndValidity();
		if (this.emisorSuperGroup.valid) {
			if (this.resumenCuenta == null) {
				Swal.fire({
					icon: "error",
					title: "Faltan datos",
					html: "Favor revisar los datos faltantes",
					confirmButtonText: "Entendido",
				});
				return;
			}

			// Verificar si hay certificaciones seleccionadas PRIMERO
			if (this.hayCertificacionesSeleccionadas) {
				this.abrirModalFechaCertificacion();
				return;
			}

			const fileControl = this.emisorSuperGroup.controls.certificado.get("file").value;
			let noCompraCertificado = this.compraCertificado.comprar == false;
			const noHayCertificado = !fileControl && !this.certificadoToSend.fileB64;
			if (noHayCertificado && noCompraCertificado) {
				Swal.fire({
					icon: "info",
					title: "No se cargó un Certificado Digital",
					html: `
					Sin certificado no podrás firmar DTE, pero sí podrás emitir Boletas de Honorarios.
					<br>
					Puedes cargarlo más adelante desde <br><b> Configuración → Certificados</b>.
					`,
					confirmButtonText: "Entendido",
				}).then((result) => {
					if (result.isConfirmed) {
						this.proceedWithSubmission();
					}
				});
				return;
			}
			if (this.resumenCuenta?.formaPago === "free" && this.compraCertificado?.comprar && this.resumenCuenta.totalCertificadoDigital > 0 && this.resumenCuenta.totalPlanes === 0 && this.resumenCuenta.totalAdicionales === 0 && this.resumenCuenta.totalCertificaciones === 0) {
				this.proceedWithSubmission();
				return;
			}

			this.proceedWithSubmission();
		} else {
			Swal.fire({
				icon: "error",
				title: "Faltan datos",
				html: "Favor revisar los datos faltantes",
				confirmButtonText: "Entendido",
			});
		}
	}

	private abrirModalFechaCertificacion(): void {
		this.fechaCertificacion = moment().format('YYYY-MM-DD');
		
		this.certificacionFechaModal = this.modalService.open(this.certificacionFechaFormTemplate, {
			size: 'md',
			backdrop: 'static',
			keyboard: false
		});

		this.certificacionFechaModal.result.then(
			(result) => {
				if (result === 'confirm') {
					const fechaMoment = moment(this.fechaCertificacion);
					this.datosFacturacion.FechaConfirmacionCertificaciones = fechaMoment.toDate();
					// Continuar con las otras validaciones después de confirmar la fecha
					this.continuarConValidaciones();
				}
			}
		);
	}

	private continuarConValidaciones(): void {
		const fileControl = this.emisorSuperGroup.controls.certificado.get("file").value;
		let noCompraCertificado = this.compraCertificado.comprar == false;
		const noHayCertificado = !fileControl && !this.certificadoToSend.fileB64;
		if (noHayCertificado && noCompraCertificado) {
			Swal.fire({
				icon: "info",
				title: "No se cargó un Certificado Digital",
				html: `
				Sin certificado no podrás firmar DTE, pero sí podrás emitir Boletas de Honorarios.
				<br>
				Puedes cargarlo más adelante desde <br><b> Configuración → Certificados</b>.
				`,
				confirmButtonText: "Entendido",
			}).then((result) => {
				if (result.isConfirmed) {
					this.proceedWithSubmission();
				}
			});
			return;
		}
		if (this.resumenCuenta?.formaPago === "free" && this.compraCertificado?.comprar && this.resumenCuenta.totalCertificadoDigital > 0 && this.resumenCuenta.totalPlanes === 0 && this.resumenCuenta.totalAdicionales === 0 && this.resumenCuenta.totalCertificaciones === 0) {
			this.proceedWithSubmission();
			return;
		}

		this.proceedWithSubmission();
	}

	private proceedWithSubmission(): void {
		// Se recolectan los datos de todos los formularios
		this.getEmisorBaseFormData();
		this.getSucursalFormData();
		this.getActivitiesFormData();
		this.getCertificadoFormData();
		this.getLogoFormData();
		this.getFacturacionFormData();

		let wizardReq: EmisorWizardRequest = new EmisorWizardRequest();
		wizardReq.emisorBase = this.emisorBaseToSend;
		wizardReq.sucursal = this.sucursalToSend;
		wizardReq.actividades = this.activitiesToSend;
		wizardReq.certificado = this.certificadoToSend;
		wizardReq.compraCertificado = this.compraCertificado;
		wizardReq.firstTime = !this.user.configured;
		wizardReq.fromPartner = this.user.isPartner;
		wizardReq.facturacion = this.datosFacturacion;
		wizardReq.usarSaldoFavor = this.resumenCuenta?.usarSaldoFavor ?? false;
		wizardReq.saldoAplicadoEsperado = wizardReq.usarSaldoFavor
			? (this.resumenCuenta?.saldoAplicadoEsperado ?? 0)
			: 0;
		if (this.logoRequest.logoFile) {
			wizardReq.logoEmisor = this.logoWizardRequest;
		}
		wizardReq.usuarioId = (this.tokenService.getUser() as SessionUser).id;
		this.formatPreviewText(wizardReq);
	}
	formatPreviewText(wizardReq: EmisorWizardRequest) {
		let previewActivities = "<ul>";
		wizardReq.actividades.forEach((act) => {
			let actividad = this.economicActivitiesSource.find((activity) => activity.actividadEconomicaId == act.actividadEconomicaId);
			let listElement = "<li>" + actividad.descripcion + "</li>";
			previewActivities += listElement;
		});
		previewActivities += "</ul>";
		let previewTiposDte = "<ul>";
		this.selectedTiposDte.forEach((tipo) => {
			let listTipo = "<li>" + tipo.nombre + "</li>";
			previewTiposDte += listTipo;
		});
		var ResumenTipoDoc = "";

		previewTiposDte += "</ul>";
		if (this.selectedTiposDte.length > 0) {
			ResumenTipoDoc = "<li ><b>Tipos Documento a Emitir</b>: " + previewTiposDte + "</li>";
		}

		let previewHtml =
			'<ul style="text-align:left;">' +
			"<li><b>Nombre</b>: " +
			wizardReq.emisorBase.razonSocial +
			"</li>" +
			"<li><b>Rut</b>: " +
			wizardReq.emisorBase.rutString +
			"</li>" +
			"<li><b>Giro</b>: " +
			wizardReq.emisorBase.giro +
			"</li>" +
			"<li><b>Dirección</b>: " +
			wizardReq.emisorBase.dirFact +
			"," +
			wizardReq.emisorBase.ciudad +
			"</li>" +
			"<li><b>Correo</b>: " +
			wizardReq.emisorBase.correoFact +
			"</li>" +
			"<li><b>Sucursal</b>: " +
			wizardReq.sucursal.nombre +
			"," +
			wizardReq.sucursal.direccion +
			"</li>" +
			ResumenTipoDoc +
			"<li><b>Actividades Economicas</b>: " +
			previewActivities +
			"</li>" +
			(this.compraCertificado.comprar ? "<li><b>Duración certificado</b>: " + this.compraCertificado.duracion + " " + (this.compraCertificado.duracion === 1 ? "año" : "años") + "</li>" : "") +
			(this.compraCertificado.comprar ? "<li><b>Garantía de reposición</b>: " + (this.compraCertificado.garantia ? "Si" : "") + "</li>" : "") +
			"</ul>";

		Swal.fire({
			icon: "question",
			title: "Resumen de creación de empresa",
			html: previewHtml,
			confirmButtonText: "Crear Empresa",
			showCancelButton: true,
			cancelButtonText: "Cancelar",
		}).then((result) => {
			if (!result.isConfirmed) {
				return;
			}
			if (this.resumenCuenta?.formaPago === "free" && this.compraCertificado?.comprar && this.resumenCuenta.totalCertificadoDigital > 0 && this.resumenCuenta.totalPlanes === 0 && this.resumenCuenta.totalAdicionales === 0 && this.resumenCuenta.totalCertificaciones === 0) {
				this.iniciarPagoCertificadoDigital(wizardReq);
			} else {
				this.requestEmisorData(wizardReq);
			}
		});
	}
	iniciarPagoCertificadoDigital(wizardReq: EmisorWizardRequest) {
		const certificado = wizardReq;
		let rutFormateado = certificado.facturacion.empresaFacturacion.rut + "-" + certificado.facturacion.empresaFacturacion.dv;
		const payload: CertificadoDigitalRequest = {
			rut: certificado.facturacion.empresaFacturacion.rutString || formatToRut(rutFormateado) || "",
			correo: certificado.facturacion.empresaFacturacion.correoFact || "",
			duracion: this.compraCertificado.duracion || 1,
			nombreEmpresa:certificado.facturacion.empresaFacturacion.razonSocial || "",
			garantia: this.compraCertificado.garantia || false,
			comuna: certificado.facturacion.empresaFacturacion.comuna|| "",
			direccion: certificado.facturacion.empresaFacturacion.dirFact|| "",
			rutEmisor: wizardReq.emisorBase?.rut.toString() || "",
			giroEmpresa: certificado.facturacion.empresaFacturacion.giro|| "",
			telefonoContacto: certificado.facturacion.empresaFacturacion.telefono.toString() || "",
			origen: OrigenCertificadoEnum.Simplefactura,
			subtotal: this.resumenCuenta?.totalCertificadoDigital || 0,
			iva: Math.round((this.resumenCuenta?.totalCertificadoDigital || 0) * 0.19),
			neto: this.resumenCuenta?.totalCertificadoDigital || 0,
			total: this.resumenCuenta?.totalCertificadoDigital || 0,
			idDatosFacturacion: certificado.facturacion.idDatoFacturacion,
			usarSaldoFavor: this.resumenCuenta?.usarSaldoFavor || false,
			saldoAplicadoEsperado: this.resumenCuenta?.saldoAplicadoEsperado || 0,
			activo: true,
		};
		const certificadoId = null;
		const emisorId = this.tokenService.getCompany();
		this.loading = true;
		this.certificadoService.initTransbank(payload, certificadoId, emisorId).subscribe({
			next: (res: any) => {
				this.loading = false;
				if (res.completado && res.pago === 'saldo') {
					this.requestEmisorData(wizardReq);
				} else if (res.urlPago && res.tokenTransbank) {
					this.webpayService.payWithWebpay(res.urlPago, res.tokenTransbank).subscribe((paymentCompleted) => {
						if (paymentCompleted) {
							this.loading = false;
							this.ref.detectChanges();
							Swal.fire({
								icon: "success",
								title: "Pago exitoso",
								text: "El pago del certificado digital se realizó correctamente.",
							}).then(() => {
								this.requestEmisorData(wizardReq);
							});
						} else {
							this.loading = false;
							this.ref.detectChanges();
							Swal.fire({
								icon: "warning",
								title: "Pago no confirmado",
								text: "No obtuvimos respuesta del pago. Si se efectuó será procesado en breves minutos.",
							});
						}
					});
				} else {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "error",
						title: "Error al iniciar pago",
						text: "No se obtuvo una URL de pago.",
					});
				}
			},
			error: (err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al iniciar pago",
					text: "Ocurrió un error iniciando el pago de tu certificado digital.",
				});
			},
		});
	}

	mostrarVentanaWebPay(): boolean {
		//Método excusivo para testing
		const attribute = document.body.getAttribute("data-mostrar-webpay");
		if (!attribute) {
			return true;
		}
		return attribute !== "false";
	}

	requestEmisorData(ewr: EmisorWizardRequest) {
		this.loading = true;
		this.ref.detectChanges(); 
		this.emisorService.processWizardEmisor(ewr).subscribe(
			(result) => {
				if (result.status == 200) {
					this.procesoFinalizado = true;
					this.limpiarBorradorWizard();
					if (result.message == "webpay") {
						if (this.mostrarVentanaWebPay()) {
							this.webpayService.payWithWebpayResult(result.data.url, result.data.token).subscribe((payment) => {
								this.loading = false;
								this.ref.detectChanges();
								if (payment.result === "Approved" && payment.paid) {
									// Ejecutar la verificación de Transbank y continuar con la generación de la factura
									Swal.fire({
										icon: "success",
										title: "Empresa Ingresada",
										text: "Se ha ingresado exitosamente la empresa " + ewr.emisorBase.razonSocial + ". Debes iniciar sesión de nuevo para operar con tu empresa.",
									}).then((result) => {
										if (result.value) {
											this.guardarLogoPublicitarioSiCorresponde(ewr, () => this.authService.logout().subscribe());
										}
									});
								} else {
									ewr.emisorBase.emisorId = result.data.emisorId;
									const paymentNames = { Rejected: "rechazado", Cancelled: "cancelado", Abandoned: "abandonado", Expired: "expirado", Pending: "pendiente" };
									const paymentName = paymentNames[payment.result] || "no aprobado";
									const trialEnd = result.data.trialEndDate ? moment(result.data.trialEndDate).format("DD/MM/YYYY") : "la fecha informada en tu plan";
									this.guardarLogoPublicitarioSiCorresponde(ewr, () => {
										Swal.fire({
											icon: "info",
											title: "Empresa disponible en DEMO",
											html: `El pago quedó <strong>${paymentName}</strong>. Tu empresa sigue disponible en DEMO hasta <strong>${trialEnd}</strong>.`,
											confirmButtonText: "Ingresar a DEMO"
										}).then(action => {
											if (action.isConfirmed) {
												this.authService.logout().subscribe();
											}
										});
									});
								}
							});
						} else {
							//Se setea el test como pagado
							this.cypressService.processManualPayment(true, ewr.facturacion.total).subscribe((data) => {
								this.loading = false;
								this.ref.detectChanges();
								if (data.status == 200) {
									Swal.fire({
										icon: "success",
										title: "Empresa Ingresada",
										text: "Se ha ingresado exitosamente la empresa " + ewr.emisorBase.razonSocial + ". Debes iniciar sesión de nuevo para operar con tu empresa.",
									}).then((result) => {
										if (result.value) {
											this.guardarLogoPublicitarioSiCorresponde(ewr, () => this.authService.logout().subscribe());
										}
									});
								}
							});
						}
					} else {
						this.loading = false;

						this.ref.detectChanges();

						//this.emisorSuperGroup.reset();
						Swal.fire({
							icon: "success",
							title: "Empresa Ingresada",
							text: "Se ha ingresado exitosamente la empresa " + ewr.emisorBase.razonSocial + ". Debes iniciar sesión de nuevo para operar con tu empresa.",
						}).then(() => {
							this.guardarLogoPublicitarioSiCorresponde(ewr, () => {
								if (this.user.configured) {
									this.router.navigateByUrl("/configuracion/empresas");
								} else {
									this.auth.logout().subscribe();
								}
							});
						});
					}
				}
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Ingresar Emisor",
					text: "No se ha podido ingresar al emisor " + ewr.emisorBase.razonSocial + ", intente nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	private guardarLogoPublicitarioSiCorresponde(ewr: EmisorWizardRequest, onComplete: () => void) {
		if (!this.logoRequest?.permisoPublicitario || !this.logoRequest?.logoLoginFile) {
			onComplete();
			return;
		}

		const rut = this.obtenerRutParaLogo(ewr.emisorBase?.rutString, ewr.emisorBase?.rut);
		if (!rut) {
			onComplete();
			return;
		}

		const request = {
			emisorId: ewr.emisorBase?.emisorId ?? null,
			rut,
			logoLoginBase64: this.logoRequest.logoLoginFile,
			permisoPublicitario: this.logoRequest.permisoPublicitario,
		};

		this.emisorService.guardarLogoPublicitario(request).subscribe({
			next: () => onComplete(),
			error: () => onComplete(),
		});
	}

	private obtenerRutParaLogo(rutString: string, rutValue?: number): number {
		if (rutValue) {
			return rutValue;
		}
		if (!rutString) {
			return null;
		}
		const rutLimpio = rutString.includes("-") ? rutString.split("-")[0] : rutString.substring(0, rutString.length - 1);
		const rutNumerico = parseInt(rutLimpio, 10);
		return Number.isNaN(rutNumerico) ? null : rutNumerico;
	}

	requestAttachedData() {
		//request for sucursal/branch-office, economic activities
		let sucursalRequest = this.emisorService.addBranchOffice(this.sucursalToSend);
		let activitiesRequest = this.emisorService.toAssignEconomicActivity(this.activitiesToSend);
	}
	getFacturacionFormData() {
		this.datosFacturacion.idPlanSf = this.resumenCuenta?.idPlanSf;
		this.datosFacturacion.origen = "wizard";
		if (!(this.datosFacturacion.idPlanSf == null || this.datosFacturacion.idPlanSf == undefined)) {
			this.datosFacturacion.certificaciones = this.certificaciones;
			const fechaTerminoPlan = this.resumenCuenta?.fechaTermino ? new Date(this.resumenCuenta.fechaTermino) : null;
			this.datosFacturacion.adicionales = (this.adicionales || []).map((adicional) => {
				const sinVencimiento =
					adicional?.idAdicional === AdicionalType.Payku ||
					(adicional?.idAdicional === AdicionalType.Recibidos && adicional?.readOnly && adicional?.precio === 0);

				return {
					...adicional,
					fechaTermino: sinVencimiento ? null : fechaTerminoPlan,
				};
			});
			this.datosFacturacion.empresaFacturacion.comuna = this.emisorSuperGroup.controls.facturacion.get("comuna").value;
			this.datosFacturacion.empresaFacturacion.dirFact = this.emisorSuperGroup.controls.facturacion.get("dirFact").value;
			this.datosFacturacion.empresaFacturacion.correoFact = this.emisorSuperGroup.controls.facturacion.get("correoFact").value;
			this.datosFacturacion.empresaFacturacion.giro = this.emisorSuperGroup.controls.facturacion.get("giro").value;
			this.datosFacturacion.empresaFacturacion.razonSocial = this.emisorSuperGroup.controls.facturacion.get("razonSocial").value;
			this.datosFacturacion.empresaFacturacion.rutString = this.emisorSuperGroup.controls.facturacion.get("rutString").value;
			this.datosFacturacion.empresaFacturacion.telefono = this.emisorSuperGroup.controls.facturacion.get("telefono").value;

			if (this.user.isPartner) {
				this.datosFacturacion.empresaFacturacion.comuna = "";
				this.datosFacturacion.empresaFacturacion.dirFact = "";
				this.datosFacturacion.empresaFacturacion.correoFact = "";
				this.datosFacturacion.empresaFacturacion.giro = "";
				this.datosFacturacion.empresaFacturacion.razonSocial = "";
				this.datosFacturacion.empresaFacturacion.rutString = "";
				this.datosFacturacion.empresaFacturacion.telefono = "0";
				this.datosFacturacion.empresaFacturacion.dv = "";
				this.datosFacturacion.empresaFacturacion.rut = 0;
			}

			if (this.datosFacturacion.empresaFacturacion.rutString) {
				const rutString = this.datosFacturacion.empresaFacturacion.rutString;
				if (!validarRut(rutString)) {
					return;
				}
				const formatted = formatToRut(rutString);
				this.datosFacturacion.empresaFacturacion.rutString = formatted;
				const parts = formatted.split("-");
				this.datosFacturacion.empresaFacturacion.rut = parseInt(parts[0].replace(/\./g, ""));
				this.datosFacturacion.empresaFacturacion.dv = parts[1];
			}
			if (this.resumenCuenta) {
				this.datosFacturacion.meses = this.resumenCuenta.meses;
				this.datosFacturacion.formaPago = this.resumenCuenta.formaPago;
				this.datosFacturacion.tipoCertificacion = this.resumenCuenta.tipoCertificacion;
				this.datosFacturacion.total = this.resumenCuenta.total;
				this.datosFacturacion.nombrePlan = this.resumenCuenta.nombrePlan;
				//this.datosFacturacion.idContratacion = this.resumenCuenta.idContratacion;
				this.datosFacturacion.idPlanUsuario = this.user.configured ? null : this.resumenCuenta.idPlanUsuario;
				this.datosFacturacion.pagado = this.resumenCuenta.pagado;
				this.datosFacturacion.codigoCupon = this.resumenCuenta.codigoCupon;
			}

			this.datosFacturacion.idDatoFacturacion = this.datosFacturacion.empresaFacturacion.emisorDatosId;
			// if(this.datosFacturacion.idDatoContratacion == null || this.datosFacturacion.idDatoContratacion == undefined){
			// 	this.datosFacturacion.idDatoContratacion = this.emisorSuperGroup.controls.facturacion.get("telefono").value;
			// 	this.datosFacturacion.empresaFacturacion
			// }
		} else {
			this.datosFacturacion = null;
		}
	}

	getEmisorBaseFormData() {
		this.emisorBaseToSend.rutString = this.emisorSuperGroup.controls.base.get("rutString").value;
		this.emisorBaseToSend.razonSocial = this.emisorSuperGroup.controls.base.get("razonSocial").value;
		this.emisorBaseToSend.giro = this.emisorSuperGroup.controls.base.get("giro").value;
		this.emisorBaseToSend.ciudad = this.emisorSuperGroup.controls.base.get("ciudad").value;
		this.emisorBaseToSend.comuna = this.emisorSuperGroup.controls.base.get("comuna").value;
		this.emisorBaseToSend.telefono = this.emisorSuperGroup.controls.base.get("telefono").value;
		this.emisorBaseToSend.dirFact = this.emisorSuperGroup.controls.base.get("dirFact").value;
		this.emisorBaseToSend.correoFact = this.emisorSuperGroup.controls.base.get("correoFact").value;
		//nuevos campos
		const cfg = this.emisorSuperGroup.controls.configuracion as FormGroup;
		this.emisorBaseToSend.fechaResol = cfg.get("fechaResol").value;
		this.emisorBaseToSend.nroResol = cfg.get("nroResol").value;
		const ambiente = cfg.get("ambiente").value;
		this.emisorBaseToSend.ambiente = ambiente?.ambienteId ?? null;
		this.emisorBaseToSend.passwordSii = cfg.get("passwordSii").value;
		this.emisorBaseToSend.unidadSII = cfg.get("unidadSII").value;
		const envio = cfg.get("envioAutomaticoCorreos").value;
		this.emisorBaseToSend.envioAutomaticoCorreos = envio;
		this.emisorBaseToSend.correoPar = this.emisorBaseToSend.correoFact;
		this.emisorBaseToSend.dirPart = this.emisorBaseToSend.dirFact;
		const rut = this.emisorBaseToSend.rutString;

		const emisorParts = RutHelper.parse(rut);
		this.emisorBaseToSend.rut = emisorParts.rut;
		this.emisorBaseToSend.dv = emisorParts.dv;
		const rutRepresentateString = this.emisorSuperGroup.controls.base.get("rutRepresentanteLegal").value;
		this.emisorBaseToSend.representanteLegalRutString = rutRepresentateString;

		const representanteParts = RutHelper.parse(rutRepresentateString);
		this.emisorBaseToSend.representanteLegalRut = representanteParts.rut;
		this.emisorBaseToSend.representanteLegalDv = representanteParts.dv;
	}

	getSucursalFormData() {
    this.sucursalToSend.nombre = this.emisorSuperGroup.controls.base.get("nombreSucursal").value;
    this.sucursalToSend.direccion = this.emisorSuperGroup.controls.base.get("direccionSucursal").value;
	}

	getActivitiesFormData() {
		this.activitiesToSend = [];
		this.economicActivitiesList.forEach((element) => {
			var newActivity = new ActividadEconomicaEmisor();
			newActivity.actividadEconomicaId = element.actividadEconomicaId;
			newActivity.emisorId = this.emisorBaseToSend.emisorId;
			this.activitiesToSend.push(newActivity);
		});
	}

	stepperInit() {
		this.stepper = new Stepper(this.stepperRef.nativeElement, {
			linear: false,
			animation: true,
		});
	}

	private async mostrarAvisoRestaurarBorrador(): Promise<boolean> {
		const userId = this.user?.id;
		if (!userId) {
			return false;
		}

		const borrador = await this.borradorWizardService.obtenerBorrador(userId);
		if (!borrador) {
			return false;
		}

		const resultado = await Swal.fire({
			icon: "info",
			title: "Borrador pendiente",
			text: "Encontramos un proceso de creación de empresa sin finalizar. ¿Deseas continuar donde lo dejaste?",
			showCancelButton: true,
			confirmButtonText: "Continuar borrador",
			cancelButtonText: "Descartar borrador",
		});

		if (resultado.isConfirmed) {
			this.restaurarBorrador(borrador);
			return true;
		}

		this.borradorWizardService.limpiarBorrador(userId);
		return true;
	}

	private restaurarBorrador(borrador: EstadoBorradorWizardEmisor): void {
		const formulario = JSON.parse(JSON.stringify(borrador.formulario ?? {}));
		if (formulario.certificado) {
			formulario.certificado.file = null;
		}
		if (formulario.logo) {
			formulario.logo.logoFile = null;
			formulario.logo.logoLoginFile = null;
		}
		this.emisorSuperGroup.patchValue(formulario);

		this.economicActivitiesList = borrador.actividades ?? [];
		this.updateActividadesEconomicasFormArray();
		this.resumenBorrador = borrador.resumenCuenta ?? null;
		this.resumenCuenta = borrador.resumenCuenta ?? null;
		this.codigosCertificacionesBorrador = (borrador.certificaciones ?? [])
			.filter((certificacion) => certificacion.solicitada)
			.map((certificacion) => certificacion.codigoPrincipal);
		this.certificaciones = borrador.certificaciones ?? [];
		this.adicionales = borrador.adicionales ?? [];
		this.compraCertificado = { ...this.compraCertificado, ...(borrador.compraCertificado ?? {}) };
		this.mostrarOpcionesCertificado = this.compraCertificado.comprar;
		this.logoRequest = Object.assign(new LogoEmisorRequest(), borrador.logo ?? {});
		this.certificadoToSend.fileB64 = borrador.certificadoFileB64 ?? undefined;
		this.certificadoRestaurado = !!this.certificadoToSend.fileB64;

		const paso = Math.max(0, Math.min(6, Number(borrador.pasoActual) || 0));
		setTimeout(() => this.navegarAIndiceWizard(paso), 0);
	}

	private async guardarBorradorAlSalir(): Promise<void> {
		const userId = this.user?.id;
		const borrador = this.construirBorrador();
		if (!userId || !borrador) {
			return;
		}

		try {
			await this.borradorWizardService.guardarBorrador(borrador, userId);
		} catch (error) {
			console.error("No fue posible guardar el borrador del wizard de empresa", error);
		}
	}

	@HostListener("input")
	@HostListener("change")
	onCambioInputWizard(): void {
		if (this.procesoFinalizado) {
			return;
		}
		clearTimeout(this.temporizadorGuardadoBorrador);
		this.temporizadorGuardadoBorrador = setTimeout(() => void this.guardarBorradorAlSalir(), 400);
	}

	@HostListener("window:beforeunload")
	@HostListener("window:pagehide")
	@HostListener("window:guardar-borrador-wizard-por-inactividad")
	guardarBorradorInmediato(): void {
		if (this.procesoFinalizado || !this.user?.id) {
			return;
		}
		const borrador = this.construirBorrador();
		if (borrador) {
			this.borradorWizardService.guardarBorradorInmediato(borrador, this.user.id);
		}
	}

	private construirBorrador(): EstadoBorradorWizardEmisor | null {
		if (!this.emisorSuperGroup || !this.tieneContenidoParaBorrador()) {
			return null;
		}

		const formulario = this.emisorSuperGroup.getRawValue();
		if (formulario.certificado) {
			formulario.certificado.file = null;
		}
		if (formulario.logo) {
			formulario.logo.logoFile = null;
			formulario.logo.logoLoginFile = null;
		}

		const { logoCompleteFile, logoLoginCompleteFile, ...logo } = this.logoRequest;
		const stepper: any = this.stepper;
		return {
			version: 1,
			actualizadoEn: new Date().toISOString(),
			pasoActual: stepper?._currentIndex ?? 0,
			formulario,
			actividades: this.economicActivitiesList,
			resumenCuenta: this.resumenCuenta,
			certificaciones: this.certificaciones ?? [],
			adicionales: this.adicionales ?? [],
			compraCertificado: this.compraCertificado,
			logo,
			certificadoFileB64: this.certificadoToSend.fileB64 ?? null,
		};
	}

	private limpiarBorradorWizard(): void {
		if (this.user?.id) {
			this.borradorWizardService.limpiarBorrador(this.user.id);
		}
	}

	private tieneContenidoParaBorrador(): boolean {
		const base = this.emisorSuperGroup.controls.base?.value ?? {};
		return Object.values(base).some((valor) => valor !== null && valor !== undefined && valor !== "") ||
			this.economicActivitiesList.length > 0 ||
			!!this.resumenCuenta ||
			!!this.certificadoToSend.fileB64;
	}

	setSuperForm() {
		this.setEmisorBaseGroup();
		//this.setSucursalFormGroup();
		this.setActivityForm();
		this.setCertificadoFormGroup();
		this.setLogoFormGroup();
		this.setFacturacionBaseGroup();
		this.setConfiguracionFormGroup();
		this.emisorSuperGroup = this.formBuilder.group({
			base: this.emisorBasicFormGroup,
			sucursal: this.emisorSucursalesFormGroup,
			actividades: this.economicActivityFormGroup,
			logo: this.logoFormGroup,
			certificado: this.certificadoFormGroup,
			configsEmision: this.configEmisionFormArray,
			pago: this.pagoFormGroup,
			configuracion: this.configuracionFormGroup,
			facturacion: this.emisorDatosFacturacionFormGroup,
		});
	}

	setFacturacionBaseGroup() {
		if (this.isSuperAdmin || this.user.isPartner) {
			this.emisorDatosFacturacionFormGroup = this.formBuilder.group({
				rutString: [""],
				razonSocial: [,],
				giro: [,],
				comuna: [,],
				telefono: [,],
				dirFact: [,],
				correoFact: [""],
				empresaSeleccionada: [],
			});
		} else {
			this.emisorDatosFacturacionFormGroup = this.formBuilder.group({
				rutString: ["", [Validators.required, Validators.minLength(8), VerificacionRutValidator]],
				razonSocial: [, Validators.required],
				giro: [, Validators.required],
				comuna: [, [Validators.required, Validators.maxLength(50)]],
				telefono: [, Validators.required],
				dirFact: [, Validators.required],
				correoFact: ["", [Validators.required, SingleEmailValidator, PlaceholderEmailValidator, Validators.maxLength(100)]],
				empresaSeleccionada: [],
			});
		}
	}

	setEmisorBaseGroup() {
		this.emisorBasicFormGroup = this.formBuilder.group({
			rutString: ["", [Validators.required, Validators.minLength(8), VerificacionRutValidator]],
			razonSocial: [, Validators.required],
			giro: [, [Validators.required, Validators.maxLength(500)]],
			ciudad: [, [Validators.required, Validators.maxLength(100)]],
			comuna: [, [Validators.required, Validators.maxLength(100)]],
			telefono: [, Validators.required],
			dirFact: [, Validators.required],
			correoFact: ["", [Validators.required, SingleEmailValidator, PlaceholderEmailValidator, Validators.maxLength(100)]],
			nombreSucursal: [, Validators.required],
			direccionSucursal: [, Validators.required],
			rutRepresentanteLegal: ["", [Validators.required, Validators.minLength(8), VerificacionRutValidator]]
		});
	}

	setConfiguracionFormGroup() {
		this.configuracionFormGroup = this.formBuilder.group({
			fechaResol: [null, Validators.required],
			// Limitamos a máximo 3 dígitos (999)
			nroResol: [null, [Validators.required, Validators.max(999)]],
			ambiente: [this.environmentType?.[0] ?? null, Validators.required],
			passwordSii: [null],
			unidadSII: [null, [Validators.required, Validators.maxLength(30)]],

			// Checkbox: TRUE = envía, FALSE = desactivado
			envioAutomaticoCorreos: [true],
		});
	}


	// SUCURSAL RELATED FUNCTIONS
	/*setSucursalFormGroup() {
		this.emisorSucursalesFormGroup = this.formBuilder.group({
			nombreSucursal: [, Validators.required],
			direccionSucursal: [, Validators.required],
		});
	}*/

	detectChangeReferenceDateAdd(event) {
		this.validDate = true;
		if (event.startDate != null && event.endDate != null) {
			this.emisorSuperGroup.controls.base.get("fechaResol").patchValue(moment(event.startDate).toDate());
		} else {
			if (event.target && event.target.value) {
				this.validDate = moment(event.target.value, "DD/MM/YYYY", true).isValid();
				if (this.validDate) {
					let newDate = moment(event.target.value, "DD-MM-YYYY").format("L");
					if (moment(this.emisorSuperGroup.controls.base.get("fechaResol").value).format("L") != newDate) {
						let dateToSave = moment(event.target.value, "DD-MM-YYYY");
						this.emisorSuperGroup.controls.base.get("fechaResol").patchValue(dateToSave.toDate());
					}
				}
			}
		}
	}

	openModalSII(modalRef) {
		this.modalSIIHelp = this.modalService.open(modalRef, {
			windowClass: "",
			size: "xl",
			centered: true,
		});
	}
	// ACTIVITY RELATED FUNCTIONS
	setActivityForm() {
		this.economicActivityFormGroup = this.formBuilder.group({
			actividadEconomica: [],
			listaActividadesEconomicas: [, Validators.required],
		});
	}

	filtro() {
		if (this.economicActivityFormGroup.get("actividadEconomica").value) {
			let selected = this.economicActivityFormGroup.get("actividadEconomica").value as ActividadEconomica;
			this.economicActivitiesSource = this.economicActivitiesSource.filter((ae) => ae.actividadEconomicaId == selected.actividadEconomicaId);
			this.economicActivitiesSource = this.economicActivitiesSource.map((ae) => ({
				...ae,
				displayText: `${ae.codigo} - ${ae.descripcion}`,
			}));
		} else {
			this.getEconomicActivitiesList();
		}
	}

	getEconomicActivitiesList() {
		this.economicActivitiesSource = JSON.parse(this.localStorage.getActividadesEconomicas()) as ActividadEconomica[];
		this.economicActivitiesSource = this.economicActivitiesSource.map((ae) => ({
			...ae,
			displayText: `${ae.codigo} - ${ae.descripcion}`,
		}));
	}

	addEconomicActivityToList() {
		let activity = this.economicActivityFormGroup.get("actividadEconomica").value as ActividadEconomica;
		if (activity) {
			let alreadyExist = this.economicActivitiesList.some((act) => act.actividadEconomicaId == activity.actividadEconomicaId);
			if (this.economicActivitiesList.length >= 4) {
				Swal.fire({
					icon: "info",
					titleText: "Cantidad Máxima",
					text: "Solo se pueden asignar 4 actividades económicas por emisor",
				});
				this.clear();
				this.getEconomicActivitiesList();
				return;
			} else if (this.economicActivitiesList.includes(activity) || alreadyExist || this.economicActivitiesList.length > 4) {
				Swal.fire({
					icon: "info",
					titleText: "La Actividad Económica ya esta asignada",
					text: "La Actividad económica ya se encuentra asignada.",
				});
				this.clear();
				this.getEconomicActivitiesList();
				return;
			} else {
				this.economicActivitiesList.push(activity);
			}
			this.clear();
			this.getEconomicActivitiesList();
			if (this.economicActivitiesList.length > 0) {
				this.economicActivityFormGroup.controls.listaActividadesEconomicas.patchValue(this.economicActivitiesList);
			}
		}

		this.ref.detectChanges();
	}
	clear() {
		this.economicActivityFormGroup.get("actividadEconomica").setValue(undefined);
	}
	deleteItem(index) {
		this.economicActivitiesList.splice(index, 1);
		if (this.economicActivitiesList.length == 0) {
			this.economicActivityFormGroup.controls.listaActividadesEconomicas.reset();
		}
	}

	//certificado functions
	setCertificadoFormGroup() {
		if (this.user.isPartner) {
			this.certificadoFormGroup = this.formBuilder.group({
				file: [],
				rutString: [],
				password: [],
			});
		} else {
			this.certificadoFormGroup = this.formBuilder.group({
				file: [],
				rutString: ["", [VerificacionRutValidator, Validators.minLength(8)]],
				password: [],
				duracion: [null],
				garantia: [false],
			});
		}
	}

	getCertificadoFormData() {
		try {
			let file = (this.emisorSuperGroup.controls.certificado as FormGroup).controls.file.value as File;

			if (file) {
				this.utilities
					.convertFileToB64String(file)
					.then((data) => {
						this.certificadoToSend.fileB64 = data.split(",")[1];
					})
					.catch((error) => {
						console.log("Error al convertir el archivo a Base64:", error);
					});
			}

			let certificado: CertificadoDigital = new CertificadoDigital();
			certificado.rutFormateado = (this.emisorSuperGroup.controls.certificado as FormGroup).controls.rutString.value;
			certificado.password = (this.emisorSuperGroup.controls.certificado as FormGroup).controls.password.value;
			this.certificadoToSend.certificadoString = JSON.stringify(certificado);
		} catch (error) {}
	}

	onFileChangeCER(files) {
		if (files.addedFiles[0].type != "application/x-pkcs12") {
			this.certificadoFormGroup.get("file").reset();
			this.certificadoFileToUpload = null;
			//this.filenameToUpload = this.fileCriteria.fileNameLabel;
			Swal.fire({
				icon: "error",
				text: "El archivo debe ser PFX",
			});
			return;
		} else {
			this.certificadoFilesArray.push(...files.addedFiles);
			this.certificadoFormGroup.controls.file.patchValue(files.addedFiles[0]);
			this.certificadoFileToUpload = files.addedFiles[0];
			let file = (this.emisorSuperGroup.controls.certificado as FormGroup).controls.file.value as File;
			this.utilities.convertFileToB64String(file).then((data) => {
				this.certificadoToSend.fileB64 = data.split(",")[1];
			});
		}
	}
	onRemoveCertificaddoArray(file: File): void {
		if (this.certificadoFilesArray.length > 1 || (this.certificadoFilesArray.length === 1 && this.certificadoFilesArray[0] !== file)) {
			const index = this.certificadoFilesArray.indexOf(file);
			if (index > -1) {
				this.certificadoFilesArray.splice(index, 1);
			}
		}
	}

	//logo functions

	setLogoFormGroup() {
		this.logoFormGroup = this.formBuilder.group({
			logoFile: [],
			propiedadLogo: [],
			plantillaImpresionPreview: [],
			permisoPublicitario: [false],
			logoLoginFile: [null],
		});
	}

	onLogoFileChange(event) {
		var fileExtensionName = this.getLogoName(event);
		if (event.rejectedFiles[0] || (fileExtensionName.toLowerCase() !== "png" && fileExtensionName.toLowerCase() !== "jpg" && fileExtensionName.toLowerCase() !== "jpeg")) {
			Swal.fire({
				icon: "error",
				title: "Error de Archivo",
				text: "El archivo ingresado no es de formato de imagen .JPG o .PNG, favor agregar un archivo con el formato correcto. Razón: " + event.rejectedFiles[0].reason == "size" ? "Tamaño" : "Tipo de archivo",
			});
		}

		this.logosFilesArray.push(...event.addedFiles);
		if (this.logosFilesArray.length > 1) {
			this.logosFilesArray.shift();
		}
		this.logoFormGroup.controls.logoFile.patchValue(this.logosFilesArray[0]);
		this.logoRequest.logoCompleteFile = this.logosFilesArray[0];
		this.logoRequest.nombre = event.addedFiles[0].name;
		this.loading = true;
		this.utilities
			.convertFileToB64String(this.logoRequest.logoCompleteFile)
			.then((data) => {
				this.logoRequest.logoFile = data.split(",")[1];
				this.loading = false;
				this.ref.detectChanges();
			})
			.catch(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	getLogoName(event): string {
		if (event.addedFiles) {
			return event.addedFiles[0].name.split(".").pop();
		} else if (event.rejectedFiles) {
			return event.rejectedFiles[0].name.split(".").pop();
		} else {
			return "";
		}
	}

	onRemoveLogo(event) {
		this.logosFilesArray.splice(this.logosFilesArray.indexOf(event), 1);
		this.logoFormGroup.controls.logoFile.patchValue(null);
		this.logoRequest.logoFile = null;
	}

	onSelectLoginLogo(event) {
		if (!event.addedFiles || event.addedFiles.length === 0) {
			if (event.rejectedFiles && event.rejectedFiles.length > 0) {
				Swal.fire({
					icon: "error",
					title: "Error de Archivo",
					text: "El logo para login debe ser en formato PNG y menor a 100 KB."
				});
			}
			return;
		}
		var fileExtensionName = this.getLogoName(event);

		if (fileExtensionName.toLowerCase() !== "png") {
			Swal.fire({
				icon: "error",
				title: "Error de Archivo",
				text: "El logo para login debe ser en formato PNG."
			});
			return;
		}
		const file = event.addedFiles[0];
		if (file.size > 100 * 1024) {
			Swal.fire({
				icon: "error",
				title: "Error de Tamaño",
				text: "El logo para login debe ser menor a 100 KB. Tamaño actual: " + (file.size / 1024).toFixed(2) + " KB"
			});
			return;
		}

		this.loginLogoFilesArray.push(...event.addedFiles);
		if (this.loginLogoFilesArray.length > 1) {
			this.loginLogoFilesArray.shift();
		}
		this.logoFormGroup.controls.logoLoginFile.patchValue(this.loginLogoFilesArray[0]);
		this.logoRequest.logoLoginCompleteFile = this.loginLogoFilesArray[0];
		this.logoRequest.nombreLogoLogin = event.addedFiles[0].name;
		this.loading = true;
		this.utilities
			.convertFileToB64String(this.logoRequest.logoLoginCompleteFile)
			.then((data) => {
				this.logoRequest.logoLoginFile = data.split(",")[1];
				this.logoLoginPreview = data;
				this.loading = false;
				this.ref.detectChanges();
			})
			.catch(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	onRemoveLoginLogo(event) {
		this.loginLogoFilesArray.splice(this.loginLogoFilesArray.indexOf(event), 1);
		this.logoFormGroup.controls.logoLoginFile.patchValue(null);
		this.logoRequest.logoLoginFile = null;
		this.logoRequest.logoLoginCompleteFile = null;
		this.logoLoginPreview = null;
	}

	getLogoFormData() {
		let logoFile = this.emisorSuperGroup.controls.logo.get("logoFile").value;
		this.logoRequest.logoCompleteFile = logoFile;
		this.logoRequest.fechaSubida = new Date();
		let propiedad = this.emisorSuperGroup.controls.logo.get("propiedadLogo").value;
		this.logoRequest.propiedadEnum = propiedad && propiedad.id ? propiedad.id : 0;
		this.logoRequest.propiedadEnumNombre = propiedad && propiedad.nombre ? propiedad.nombre : "contain";
		this.logoRequest.permisoPublicitario = this.emisorSuperGroup.controls.logo.get("permisoPublicitario").value;
		const loginFile = this.emisorSuperGroup.controls.logo.get("logoLoginFile").value;
		if (loginFile) {
			this.logoRequest.logoLoginCompleteFile = loginFile;
		}
		this.logoWizardRequest.fileB64 = this.logoRequest.logoFile;
		if (this.logoRequest.logoFile) {
			this.logoWizardRequest.logoString = JSON.stringify(this.logoRequest);
		}
	}

	setAddress() {
		const direccionTemp = this.emisorSuperGroup.controls.base.get("dirFact").value;
		this.emisorSuperGroup.controls.base.get("direccionSucursal").setValue(direccionTemp);
		this.emisorSuperGroup.controls.base.get("nombreSucursal").setValue("Casa Matriz");
	}

	setRepresentanteLegal() {
		let rutRep = this.emisorSuperGroup.controls.base.get("rutRepresentanteLegal").value;
		this.emisorSuperGroup.controls.certificado.get("rutString").setValue(rutRep);
	}

	//generic functions of wizard

	checkValidityOfCurrentForm(stepIndex) {
		this.submittedChildrenFormsArray[stepIndex] = true;
		switch (stepIndex) {
			case 0:
				 if (this.showDomiciliosCombo && this.domiciliosFromSii.length > 1) {
					return this.emisorSuperGroup.controls.base.valid && 
						this.validDate && 
						this.domicilioSeleccionado != null;
				}
				return this.emisorSuperGroup.controls.base.valid && this.validDate;
			case 1:
				return this.emisorSuperGroup.controls.actividades.valid;
			case 2:
				return this.user.isPartner ? true : this.emisorSuperGroup.controls.certificado.valid;
			case 3:
				return this.logoRequest.logoFile || this.logoRequest.logoLoginFile ? this.emisorSuperGroup.controls.logo.valid : true; //Si el logo esta agregado, valida el formulario, de lo contrario se considera correcto
			case 4:
				var valid = this.resumenCuenta != null;
				if (!valid && !this.user.isPartner) {
					Swal.fire({
						icon: "info",
						title: "Validación de Resumen de Cuenta",
						text: "Debe seleccionar un plan de facturación",
					});
				}
				if (valid && !this.validarTotalesResumenAntesDeFacturacion()) {
					return false;
				}
				return this.resumenCuenta != null || this.user.isPartner;
			case 5:
				return this.emisorSuperGroup.controls.configuracion.valid;
			case 6:
				return this.emisorSuperGroup.controls.facturacion.valid;
		}
	}

	private validarTotalesResumenAntesDeFacturacion(): boolean {
		const total = this.resumenCuenta?.total ?? 0;
		const totalCertificadoDigital = this.resumenCuenta?.totalCertificadoDigital ?? 0;

		if (total < 0 || totalCertificadoDigital < 0) {
			Swal.fire({
				icon: "warning",
				title: "Validación de Totales",
				text: "Los Totales pueden ser negativos.",
			});
			return false;
		}

		if (this.resumenCuenta?.formaPago !== "free" && total <= 0 && totalCertificadoDigital <= 0) {
			Swal.fire({
				icon: "warning",
				title: "Validación de Totales",
				text: "Los totales no pueden ser cero o negativos.",
			});
			return false;
		}

		return true;
	}

	validateCertificate($event) {
		if (!this.user.isPartner) {
			this.getCertificadoFormData();
			this.loading = true;
			if (this.emisorSuperGroup.controls.certificado.valid && this.certificadoToSend.fileB64 != undefined) {
				this.certificadoService.validateCertificate(this.certificadoToSend).subscribe(
					(res) => {
						this.loading = false;
						this.ref.detectChanges();
						if (res.data) {
							this.next($event);
						} else
							Swal.fire({
								icon: "info",
								title: "Validación de Certificado",
								text: res.message,
							});
					},
					(err) => {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "error",
							title: "Validación de Certificado",
							text: "No fue posible validar password del certificado. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(err.error),
						});
					}
				);
			} else {
				this.loading = false;
				this.ref.detectChanges();
				this.next($event);
			}
		} else {
			this.next($event);
		}
	}

	restrictNroResolLength(event: any) {
		try {
			const control = this.emisorSuperGroup?.controls?.configuracion as FormGroup;
			if (!control) return;
			let val = event?.target?.value;
			if (val === null || val === undefined) return;
			val = val.toString();
			val = val.replace(/\D/g, "");
			if (val.length > 3) val = val.substr(0, 3);
			const numeric = val === "" ? null : parseInt(val, 10);
			control.get('nroResol').setValue(numeric);
		} catch (e) {
		}
	}
	comprobar($event) {
		const rut = $event.currentTarget.value;

		if (this.searchingCompany || this.prevSearch == rut) {
			return;
		}

		if (rut && rut !== "" && validarRut(rut)) {
			this.emisorSuperGroup.controls.base.get("rutString").patchValue(formatToRut(rut));
			this.prevSearch = rut;
		}

		if (this.emisorSuperGroup.controls.base.get("rutString").valid && rut && rut !== "" && rut.length > 7) {
			this.searchingCompany = true;
			this.prevSearch = rut;
			this.emisorService.findEmisorByRut(rut).subscribe(
				(res) => {
					if (res.data) {
						this.loading = false;
						this.searchingCompany = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "info",
							title: "Comprobación Rut Emisor",
							text: res.message,
						});
						this.emisorSuperGroup.controls.base.get("rutString").setValue("");
					} else {
						this.buscarDatosEnSii(rut);
					}
				},
				(err) => {
					this.buscarDatosEnSii(rut);
				}
			);
		}
	}

	private buscarDatosEnSii(rut: string) {
		this.loading = false;
		let isCancelled = false;
		const cancelSubject = this.siiSearchService.showCompanySearchModal();

		this.clientService
			.getFromSii(rut, this.emisorId)
			.pipe(takeUntil(cancelSubject))
			.subscribe(
				(data) => {
					if (isCancelled) return;
					this.siiSearchService.closeSearchModal();
					this.loading = false;
					this.searchingCompany = false;

					if (data.status == 200 && data.data) {
						this.llenarFormularioConDatosSii(data.data, rut);
						//this.buscarDatosResolucion(rut);
					} else {
						this.mostrarMensajeSinDatos(rut);
					}
					this.ref.detectChanges();
				},
				(error) => {
					if (isCancelled) return;
					this.siiSearchService.closeSearchModal();
					this.loading = false;
					this.searchingCompany = false;
					this.prevSearch = undefined;
					if (error.status === 500 && !isCancelled) {
						this.mostrarMensajeSinDatos(rut);
					}
					this.ref.detectChanges();
				}
			);

		cancelSubject.pipe(takeUntil(this.destroy$)).subscribe(() => {
			isCancelled = true;
			this.loading = false;
			this.searchingCompany = false;
			this.prevSearch = undefined;
		});
	}

	private llenarFormularioConDatosSii(datosSii: any, rut: string) {
		if (datosSii.razonSocial) {
			this.emisorSuperGroup.controls.base.get("razonSocial").patchValue(datosSii.razonSocial);
		}
		if (datosSii.giro) {
			this.emisorSuperGroup.controls.base.get("giro").patchValue(datosSii.giro);
		}
		if (datosSii.correoFact) {
			this.emisorSuperGroup.controls.base.get("correoFact").patchValue(datosSii.correoFact);
		}

		if (datosSii.domicilios && datosSii.domicilios.length > 0) {
			this.domiciliosFromSii = datosSii.domicilios.map((dom: any) => ({
				direccion: dom.direccion || dom.dirFact || "",
				ciudad: dom.ciudad || "",
				comuna: dom.comuna || ""
			}));
			if (this.domiciliosFromSii.length > 1) {
				this.showDomiciliosCombo = true;
				this.seleccionarDomicilio(this.domiciliosFromSii[0]);
			} else if (this.domiciliosFromSii.length === 1) {
				this.seleccionarDomicilio(this.domiciliosFromSii[0]);
				this.showDomiciliosCombo = false;
			}
		} else {
			this.showDomiciliosCombo = false;
			this.domiciliosFromSii = [];

			if (datosSii.dirFact) {
				this.emisorSuperGroup.controls.base.get("dirFact").patchValue(datosSii.dirFact.trim());
			}
			if (datosSii.ciudad) {
				this.emisorSuperGroup.controls.base.get("ciudad").patchValue(datosSii.ciudad);
			}
			if (datosSii.comuna) {
				this.emisorSuperGroup.controls.base.get("comuna").patchValue(datosSii.comuna);
			}
		}

		if (datosSii.giro) {
			this.economicActivitiesList = [];
			const giroSii = datosSii.giro.toLowerCase().trim();
			const actividadesEncontradas = this.economicActivitiesSource.filter((ae) => {
				const descripcionAE = ae.descripcion.toLowerCase().trim();
				return descripcionAE === giroSii || descripcionAE.includes(giroSii) || giroSii.includes(descripcionAE);
			});

			if (actividadesEncontradas.length > 0) {
				actividadesEncontradas.slice(0, 3).forEach((actividad) => {
					const actividadNoExiste = !this.economicActivitiesList.find((a) => a.codigo === actividad.codigo);
					if (actividadNoExiste) {
						this.economicActivitiesList.push(actividad);
					}
				});
				this.updateActividadesEconomicasFormArray();
			}
		}
		this.ref.detectChanges();
	}
	public agregarDireccionPersonalizada = (term: string) => {
		return {
			direccion: term,
			ciudad: '',
			comuna: '',
			esPersonalizada: true
		};
	};

	public seleccionarDomicilio(domicilio: any): void {
		if (domicilio) {
			this.domicilioSeleccionado = domicilio;
			if (domicilio.esPersonalizada) {
				this.emisorSuperGroup.controls.base.get("dirFact").patchValue(domicilio.direccion);
				this.emisorSuperGroup.controls.base.get("ciudad").patchValue('');
				this.emisorSuperGroup.controls.base.get("comuna").patchValue('');
			} else {
				this.emisorSuperGroup.controls.base.get("dirFact").patchValue(domicilio.direccion);
				this.emisorSuperGroup.controls.base.get("ciudad").patchValue(domicilio.ciudad);
				this.emisorSuperGroup.controls.base.get("comuna").patchValue(domicilio.comuna);
			}
			
			this.emisorSuperGroup.controls.base.get("dirFact").markAsTouched();
			this.emisorSuperGroup.controls.base.get("ciudad").markAsTouched();
			this.emisorSuperGroup.controls.base.get("comuna").markAsTouched();
			
			this.ref.detectChanges();
		}
	}
	public limpiarSeleccionDomicilio(): void {
		this.domicilioSeleccionado = null;
		this.emisorSuperGroup.controls.base.get("dirFact").patchValue("");
		this.emisorSuperGroup.controls.base.get("ciudad").patchValue("");
		this.emisorSuperGroup.controls.base.get("comuna").patchValue("");
		this.ref.detectChanges();
	}


	private mostrarMensajeSinDatos(rut: string) {
		Swal.fire({
			text: "El RUT " + rut + " no tiene registros en el SII o no se pudo obtener información. Se debe agregar manualmente",
			title: "Sin datos en el SII",
			showConfirmButton: true,
			allowOutsideClick: false,
			allowEscapeKey: false,
		});
	}

	private updateActividadesEconomicasFormArray() {
		const control = this.emisorSuperGroup.controls.actividades.get("listaActividadesEconomicas");
		if (control) {
			control.patchValue(this.economicActivitiesList);
		}
	}

	actualizarCert(certificaciones) {
		this.certificaciones = certificaciones;
	}

	actualizarResumen(resumen: Resumen) {
		this.resumenCuenta = resumen;
		this.adicionales = resumen.adicionales || [];
		if (this.user.configured) this.resumenCuenta.idContratacion = null;
	}

	reuseData(value) {
		if (value == true) {
			this.emisorSuperGroup.controls.facturacion.get("rutString").setValue(this.emisorSuperGroup.controls.base.get("rutString").value);
			this.emisorSuperGroup.controls.facturacion.get("razonSocial").setValue(this.emisorSuperGroup.controls.base.get("razonSocial").value);
			this.emisorSuperGroup.controls.facturacion.get("giro").setValue(this.emisorSuperGroup.controls.base.get("giro").value);
			this.emisorSuperGroup.controls.facturacion.get("comuna").setValue(this.emisorSuperGroup.controls.base.get("comuna").value);
			this.emisorSuperGroup.controls.facturacion.get("telefono").setValue(this.emisorSuperGroup.controls.base.get("telefono").value);
			this.emisorSuperGroup.controls.facturacion.get("dirFact").setValue(this.emisorSuperGroup.controls.base.get("dirFact").value);
			this.emisorSuperGroup.controls.facturacion.get("correoFact").setValue(this.emisorSuperGroup.controls.base.get("correoFact").value);
			this.emisorSuperGroup.controls.facturacion.get("empresaSeleccionada").setValue(null);
		} else {
			if (this.empresasFacturacionSource.length > 0) {
				this.emisorSuperGroup.controls.facturacion.get("empresaSeleccionada").setValue(this.empresasFacturacionSource[0]);
				//this.selectedEmpresa = this.empresasFacturacionSource[0];
				this.filtroEmpresasFacturacion();
			} else {
				this.emisorSuperGroup.controls.facturacion.get("rutString").setValue("");
				this.emisorSuperGroup.controls.facturacion.get("razonSocial").setValue("");
				this.emisorSuperGroup.controls.facturacion.get("giro").setValue("");
				this.emisorSuperGroup.controls.facturacion.get("comuna").setValue("");
				this.emisorSuperGroup.controls.facturacion.get("telefono").setValue("");
				this.emisorSuperGroup.controls.facturacion.get("dirFact").setValue("");
				this.emisorSuperGroup.controls.facturacion.get("correoFact").setValue("");
			}
		}
		this.ref.detectChanges();
	}

	filtroEmpresasFacturacion() {
		const selectedEmpresa = this.emisorSuperGroup.controls.facturacion.get("empresaSeleccionada").value;
		if (selectedEmpresa != null && selectedEmpresa != undefined) {
			this.datosFacturacion.empresaFacturacion = selectedEmpresa;

			this.emisorSuperGroup.controls.facturacion.get("rutString").setValue(selectedEmpresa.rut + "-" + selectedEmpresa.dv);
			this.emisorSuperGroup.controls.facturacion.get("razonSocial").setValue(selectedEmpresa.razonSocial);
			this.emisorSuperGroup.controls.facturacion.get("giro").setValue(selectedEmpresa.giro);
			this.emisorSuperGroup.controls.facturacion.get("comuna").setValue(selectedEmpresa.comuna);
			this.emisorSuperGroup.controls.facturacion.get("telefono").setValue(selectedEmpresa.telefono);
			this.emisorSuperGroup.controls.facturacion.get("dirFact").setValue(selectedEmpresa.dirFact);
			this.emisorSuperGroup.controls.facturacion.get("correoFact").setValue(selectedEmpresa.correoFact);
			this.ref.detectChanges();
		}
	}

	onValueChangeComboEmpresa(value: any) {
		if (value === null || value === undefined) {
			// El valor del ng-select ha sido limpiado
			this.emisorSuperGroup.controls.facturacion.get("rutString").setValue(this.emisorSuperGroup.controls.base.get("rutString").value);
			this.emisorSuperGroup.controls.facturacion.get("razonSocial").setValue(this.emisorSuperGroup.controls.base.get("razonSocial").value);
			this.emisorSuperGroup.controls.facturacion.get("giro").setValue(this.emisorSuperGroup.controls.base.get("giro").value);
			this.emisorSuperGroup.controls.facturacion.get("comuna").setValue(this.emisorSuperGroup.controls.base.get("comuna").value);
			this.emisorSuperGroup.controls.facturacion.get("telefono").setValue(this.emisorSuperGroup.controls.base.get("telefono").value);
			this.emisorSuperGroup.controls.facturacion.get("dirFact").setValue(this.emisorSuperGroup.controls.base.get("dirFact").value);
			this.emisorSuperGroup.controls.facturacion.get("correoFact").setValue(this.emisorSuperGroup.controls.base.get("correoFact").value);
			this.emisorSuperGroup.controls.facturacion.get("empresaSeleccionada").setValue(null);
			// Aquí puedes añadir la lógica que desees ejecutar cuando el control se limpia
		}
	}

	guardarCertificado(): void {
		const correoFactControl = this.emisorSuperGroup.get("base.correoFact");
		if (correoFactControl?.invalid) {
			correoFactControl.markAsTouched();
			this.submittedChildrenFormsArray[0] = true;
			Swal.fire({
				icon: "warning",
				title: "Correo requerido para comprar certificado",
				text: correoFactControl.hasError("placeholderEmail")
					? "Debes ingresar un correo valido. No se permite usar sincorreo@sincorreo.cl para la compra del certificado digital."
					: "Debes ingresar un correo valido antes de anadir el certificado digital a la compra.",
			});
			return;
		}

		const duracion = this.emisorSuperGroup.get("certificado.duracion").value;
		const garantia = this.emisorSuperGroup.get("certificado.garantia").value;
		this.compraCertificado.comprar = true;
		this.compraCertificado.duracion = duracion;
		this.compraCertificado.garantia = garantia;
		this.compraCertificado.certificadoGenerado = false;
		this.recalcularPrecioCertificado();
		this.pagoService.triggerCalculations();
		this.ref.detectChanges();
		Swal.fire({
			icon: "success",
			title: "¡Añadido carrito!",
			text: 'Cuando ingreses a la app, debes crear tu Certificado Digital mediante el botón "Crea tu Certificado". Este certificado lo verás en el paso 5 (Pago de plan).',
		});
	}

	cambiarOpcionCertificado(valor: boolean): void {
		this.mostrarOpcionesCertificado = valor;
		this.ref.detectChanges();
	}

	public recalcularPrecioCertificado(): void {
		const duracion = this.emisorSuperGroup.get("certificado.duracion").value;
		const garantia = this.emisorSuperGroup.get("certificado.garantia").value;

		if (!duracion) {
			this.compraCertificado.preciobase = 0;
			this.compraCertificado.precioGarantia = 0;
			this.compraCertificado.total = 0;
			this.ref.detectChanges();
			return;
		}

		this.certificadoService.getTarifasCertificado().subscribe({
			next: (data) => {
				const precioCert = data.find((t) => t.nombreProducto == "Certificado Digital" && t.anios === duracion);
				const precioGarantia = data.find((t) => t.nombreProducto.toLowerCase().includes("garantía") && t.anios === duracion);

				this.compraCertificado.preciobase = precioCert ? precioCert.precio : 0;
				this.compraCertificado.precioGarantia = garantia && precioGarantia ? precioGarantia.precio : 0;
				this.compraCertificado.total = this.compraCertificado.preciobase + this.compraCertificado.precioGarantia;
				this.ref.detectChanges();
			},
			error: () => {
				this.compraCertificado.preciobase = 0;
				this.compraCertificado.precioGarantia = 0;
				this.compraCertificado.total = 0;
				this.ref.detectChanges();
			},
		});
	}

	get certificadoDuracion(): number | null {
		return this.emisorSuperGroup?.get("certificado.duracion")?.value;
	}

	onEliminarCert(): void {
		this.compraCertificado.comprar = false;
		this.compraCertificado.duracion = null;
		this.compraCertificado.garantia = false;
		this.compraCertificado.preciobase = 0;
		this.compraCertificado.precioGarantia = 0;
		this.compraCertificado.total = 0;
		this.mostrarOpcionesCertificado = false;
		this.emisorSuperGroup.get("certificado.duracion").setValue(null);
		this.emisorSuperGroup.get("certificado.garantia").setValue(false);
		this.recalcularPrecioCertificado();
		this.pagoService.triggerCalculations();

		Swal.fire({
			icon: "info",
			title: "Certificado eliminado",
			text: "El certificado digital ya no se incluirá en tu compra.",
		});
	}
}
